import { ImageGalleryModal } from '../ImageGalleryModal'

type Props = {
  open: boolean
  onClose: () => void
  images: string[] | null
}

export const EntityImagePreviewModal = ({ open, onClose, images }: Props) => (
  <ImageGalleryModal open={open} onClose={onClose} images={images} initialIndex={0} />
)
